export default __webpack_public_path__ + "68495778dd9f5669a966b65e8ba1d92d.svg";